class APIConnector {
    _url = '';
    _endpoints = []
    _data = {}
    constructor(url, endpoints) {
        this._url = url || '/api/';
        this._endpoints = endpoints || [];
        this._data = {}
    }
    get data() {
        return this._data;
    }
    get endpoints() {
        return this._endpoints;
    }
    getDataByEndpoint = (endpoint) => {

    }
    addEndpoint = (endpoint) => {
        if (!this.endpoints.includes(endpoint)) this.endpoints.push(endpoint);
    }

    getData = async (endpoint) => {
        try {
            return fetch(this._url + endpoint)
                .then((response) => response.json())
                .then((data) => {
                    this._data[endpoint] = data;
                    return (data);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        } catch (error) {
            console.error('Error:', error);

        }
    }
}

export { APIConnector }